import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import classes from './NotFound.module.scss';

interface NotFoundProps {
    title?: string;
    subtitle?: string;
    customContainerClass?: string;
}

const NotFound: React.FC<NotFoundProps> = ({
    title = 'Not Found',
    subtitle = "We couldn't find what you're looking for.",
    customContainerClass
}) => {
    return (
        <div className={`${classes.notFoundContainer} ${customContainerClass || ''}`.trim()}>
            <div className={classes.notFoundWrapper}>
                <div className={classes.notFoundBadge}>
                    <FontAwesomeIcon icon={faSearch} />
                </div>
                <div className={classes.notFoundContent}>
                    <div className={classes.notFoundTitle}>{title}</div>
                    <div className={classes.notFoundSubtitle}>{subtitle}</div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
